import { render, staticRenderFns } from "./PaymenScreen.vue?vue&type=template&id=5bf648be&scoped=true"
import script from "./PaymenScreen.vue?vue&type=script&lang=js"
export * from "./PaymenScreen.vue?vue&type=script&lang=js"
import style0 from "./PaymenScreen.vue?vue&type=style&index=0&id=5bf648be&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bf648be",
  null
  
)

export default component.exports